import { Textarea } from '@heroui/react';
import React from 'react';

export interface FormTextAreaProps {
  /** Input field ID */
  id: string;
  /** Input field name */
  name?: string;
  /** Input field label */
  label: string;
  /** Input field value */
  value?: string;
  /** Placeholder text */
  placeholder?: string;
  /** Whether the field is required */
  required?: boolean;
  /** Whether the field is disabled */
  disabled?: boolean;
  /** Whether the field is invalid */
  isInvalid?: boolean;
  /** Error message to display */
  errorMessage?: string;
  /** Number of initial rows */
  rows?: number;
  /** Change handler */
  onChange?: (value: string) => void;
  /** Additional CSS classes */
  className?: string;
}

export const TextArea: React.FC<FormTextAreaProps> = ({
  id,
  name,
  label,
  value,
  placeholder,
  required = false,
  disabled = false,
  isInvalid = false,
  errorMessage,
  rows = 3,
  onChange,
  className = '',
}) => {
  const textareaClassNames = {
    input: 'text-foreground bg-transparent px-3 py-2',
    inputWrapper:
      'bg-default-50 border-default-200 hover:border-default-300 focus-within:border-primary shadow-sm hover:shadow-md transition-all duration-200',
    base: 'w-full',
    label: 'text-sm font-medium text-foreground',
  };

  return (
    <div className={`space-y-2 ${className}`}>
      <Textarea
        label={label}
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        variant="bordered"
        isDisabled={disabled}
        isInvalid={isInvalid}
        isRequired={required}
        errorMessage={errorMessage}
        onValueChange={onChange}
        minRows={rows}
        maxRows={rows + 5}
        disableAutosize={false}
        classNames={textareaClassNames}
      />
    </div>
  );
};
